import { makeStyles } from '@material-ui/core';

export const useStepStyles = makeStyles(theme => ({
  root: {
    background: 'transparent',
    [theme.breakpoints.down('xs')]: {
      padding: '20px 0',
    },
  },
  steplabel: {
    fontSize: '1em',
    [theme.breakpoints.down('xs')]: {
      fontSize: '0.85em',
    }
  },
}));

export const useBrandSelectionStyles = makeStyles(theme => ({
  searchContainer: {
    width: '100%',
    maxWidth: '550px',
  },
  lettersInstructions: {
    textAlign: 'left'
  },
}));

export const useOwnerStyles = makeStyles(theme => ({
  wrapper: {
    textAlign: 'left',
  },
  heading: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '10px',
    '& h3, & p': {
      margin: '0 0 15px',
    },
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
      marginBottom: '20px',
      '& > div': {
        width: '100%',
      },
      '& > div:first-child': {
        order: '2',
      },
      '& > div:nth-child(2)': {
        order: '3',
      },
      '& > div:last-child': {
        order: '1',
      },
    },
  },
  form: {
    backgroundColor: '#EBECEF',
    padding: '10px 15px',
    '& .MuiInputBase-input': {
      backgroundColor: theme.custom.white,
    }
  },
  formTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px 0',
    '& h3': {
      margin: 0,
    },
    '& .owner-handle': {
      cursor: 'move',
    },
  },
}));

export const useFormStyles = makeStyles(theme => ({
  root: {
    textAlign: 'left',
    width: '100%',
    '& .row': {
      display: 'flex',
      flexWrap: 'wrap',
      '& > *': {
        flex: '1',
        [theme.breakpoints.down('xs')]: {
          flex: 'initial',
        },
      },
      '&.row-3 > *:first-child': {
        [theme.breakpoints.down('xs')]: {
          width: 'calc(100% - 10px)',
        },
      },
      '&.row-3 > *:not(:first-child)': {
        [theme.breakpoints.down('xs')]: {
          width: 'calc(50% - 10px)',
        },
      },
      '&.row-4 > *, &.row-2 > *': {
        [theme.breakpoints.down('xs')]: {
          width: 'calc(50% - 10px)',
        },
      },
      '&.row-1': {
        flexDirection: 'column',
      },
      '&.row-1 > *': {
        margin: '5px',
      },
      '& h4': {
        margin: '0',
        color: theme.custom.gray500,
        fontWeight: 'bold',
      },
      '& .MuiCheckbox-root': {
        padding: '0 9px',
      },
      '& .MuiCheckbox-root + span': {
        fontSize: '14px',
        color: theme.custom.gray500,
      },
    },
    '& > .MuiTextField-root, & > .MuiFormControl-root': {
      width: 'calc(100% - 10px)',
    },
    '& > .MuiTextField-root, & .row > .MuiTextField-root, & > .MuiFormControl-fullWidth': {
      margin: '5px',
    },
    '& > .MuiInputBase-root, & .row > .MuiInputBase-root': {
      margin: '5px',
    },
    '& > .MuiFormControl-root, & .row > .MuiFormControl-root': {
      margin: '5px',
    },
    '& .MuiOutlinedInput-inputMarginDense': {
      padding: '8px 14px',
      fontSize: '15px',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-marginDense': {
      fontSize: '15px',
      transform: 'translate(14px, 9px) scale(1)',
    },
    '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
      transform: 'translate(14px, -6px) scale(0.75)',
    },
  },
  draggable: {
    display: 'flex',
    marginBottom: '20px',
    '& .owner-handle': {
      width: '8px',
      backgroundColor: '#cccccc',
      cursor: 'move',
    },
    '& > div': {
      flex: '1',
    },
  },
}));

export const useBrandPositionStyles = makeStyles(theme => ({
  img: {
    maxWidth: '100%',
    display: 'block',
    margin: 'auto',
  },
  radios: {
    margin: '20px 0',
    '& .MuiFormControlLabel-label': {
      fontSize: '14px',
    },
  },
}));

export const useAnimalSelectionStyles = makeStyles((theme) => ({
  wrapper: {
    padding: '30px 0 0',
    textAlign: 'center',
  },
  svg: {
    overflow: 'hidden',
    '&.horse': {
      maxWidth: '750px',
      height: '250px',
      display: 'block',
      position: 'relative',
      margin: '0 auto 20px',
    },
    '&.sheep': {
      maxWidth: '600px',
      height: '310px',
      display: 'block',
      position: 'relative',
      margin: 'auto',
    },
    '& svg': {
      width: '100%',
      height: 'auto',
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate3d(-50%, -50%, 0)',
    },
    '& .selectable': {
      transition: 'opacity 0.2s',
      opacity: '0',
      cursor: 'pointer',
    },
    '& .selectable.hover': {
      opacity: '0.5',
    },
    '& .selectable.active': {
      opacity: '0.9',
    },
    '& .brand-placement': {
      cursor: 'pointer',
    },
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: '0 -15px 20px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
    '& > div': {
      width: '50%',
      padding: '0 15px',
      [theme.breakpoints.down('xs')]: {
        width: '100%',
      },
    },
  },
  rowThree: {
    display: 'flex',
    alignItems: 'flex-start',
    margin: '0 -15px 20px',
    flexWrap: 'wrap',
    '& > div': {
      width: 'auto',
      flex: '1',
      padding: '0 15px',
    },
    '& > div:not(:last-child)': {
      [theme.breakpoints.down('xs')]: {
        flex: 'initial',
        width: '100%',
      },
    },
    '& > div:first-child': {
      [theme.breakpoints.down('xs')]: {
        order: '2',
      },
    },
    '& > div:nth-child(2)': {
      [theme.breakpoints.down('xs')]: {
        order: '1',
      },
    },
    '& > div:last-child': {
      '@media (max-width: 900px)': {
        flex: 'initial',
        width: '100%',
      },
      [theme.breakpoints.down('xs')]: {
        order: '3',
      },
    },
  },
}));
